
let plek_main = {

    event_add_page_id: null,
    event_edit_page_id: null,
    postloader_content: {},// The content that gets loaded afterwards
    request_sent: {}, //Stores the ID's of the buttons clicked to avoid double entires
    event_poster_min_dimensions: { width: 800, height: 800 }, //The minimal dimensions for event poster
    infinite_scroll_observer: null,
    send_form_ongoing: {}, //Keeps track of the send_form requests sent

    construct() {
        jQuery(window).resize();
        jQuery(document).ready(function () {

            plek_main.add_event_listener();
            plek_main.content_loader();

            //Config and run the Topbar function
            if (plek_main.config_topbar()) {
                topbar.show();
            }

            //Loads the content via ajax
            plek_main.do_postloader();

            //Checks the first heartbeat after loading
            if (!empty(wp.heartbeat)) {
                setTimeout(() => {
                    wp.heartbeat.connectNow();
                }, 500)
            }
        });

        //Check for event notification
        if (typeof plek_add_event_functions !== 'undefined' && !empty(plek_add_event_functions)) {
            setTimeout(() => {
                plek_add_event_functions.maybe_display_event_details_reminder();
            }, 3000)
        }

    },

    config_topbar() {
        if (typeof topbar !== 'undefined' && !empty(topbar)) {
            topbar.config({
                autoRun: true,
                barThickness: 3,
                barColors: {
                    '0': '#8C262E',
                    '1.0': '#8C262E'
                },
                shadowBlur: 10,
                shadowColor: 'rgba(0,   0,   0,   .6)'
            })
            return true;
        }
        return false;
    },


    /**
     * Activates the button loader and sets the button text
     * @param {object | string} element - The element to activate the loader on. Should be an html element or #element_id
     * @param {string} text - The text to put on the button
     */
    activate_button_loader(element, text) {
        this.activate_loader_style(element);
        if (text === null) {
            return; //Don't change the text when it is not specified
        }
        if (jQuery(element).hasClass("plek-counter-button")) {
            jQuery(element).find('.label').text(text);
        }
        else if (jQuery(element).is("input")) {
            jQuery(element).val(text);
        } else {
            jQuery(element).html(text);
        }
    },
    /**
     * Deactivates the button loader and sets the button text back to the original
     * @param {*} element - The element to deactivate the loader on. Should be an html element or #element_id
     * @param {*} text - The original text of the button
     */
    deactivate_button_loader(element, text = null) {
        this.deactivate_loader_style(element);
        if (text === null) {
            return; //Don't change the text when it is not specified
        }
        if (jQuery(element).hasClass("plek-counter-button")) {
            jQuery(element).find('.label').text(text);
        }
        else if (jQuery(element).is("input")) {
            jQuery(element).val(text);
        } else {
            jQuery(element).html(text);
        }
    },
    /**
     * Deactivates a button by adding the class "deactivate" to it and setting the disabled property to true.
     * @param {*} element - The element to deactivate. Should be an html element or #element_id
     */
    deactivate_button(element) {
        jQuery(element).addClass('deactivate');
        jQuery(element).prop('disabled', true);
    },
    /**
     * Activates a button by removing the class "deactivate" and setting the disabled property to false.
     * @param {*} element - The element to activate. Should be an html element or #element_id
     */
    activate_button(element) {
        jQuery(element).removeClass('deactivate');
        jQuery(element).prop('disabled', false);
    },
    disable_button(element) {
        jQuery(element).addClass('disable');
    },

    /**
     * Activates the loader style for the element.
     * @param {object} element 
     */
    activate_loader_style(element) {
        jQuery(element).addClass('loader');
        if (jQuery(element).is("input")) {
            //Loader does not work on input fields. Add loader after button
            let btn_id = jQuery(element).attr('id');
            jQuery(element).after(`<div id='input_loader_${btn_id}' class='input_loader'></div>`);
            //Set the width of the loader
            jQuery(`#input_loader_${btn_id}`).width(jQuery(element).width());
        }
    },

    /**
     * Deactivates the loader style for the element.
     * @param {object} element - The element to deactivate the loader on. Should be an html element or #element_id
     */
    deactivate_loader_style(element) {
        jQuery(element).removeClass('loader');
        if (jQuery(element).is("input")) {
            //Loader does not work on input fields. Add loader after button
            let btn_id = jQuery(element).attr('id');
            jQuery('#input_loader_' + btn_id).remove();

        }
    },

    /**
     * Adds an infinite loader to the parent of blockContainer.
     * @param {object} blockContainer - The container that the loader should be added to.
     */
    activateEventInfiniteLoader(blockContainer) {
        const loader = "<div class='plek-infinite-loader'><div class='poster'></div><div class='details'><div></div><div></div></div></div>";
        jQuery(blockContainer).parent().append(loader);
    },

    /**
     * Removes the infinite loader to the parent of blockContainer.
     * @param {object} blockContainer - The container that the loader should be added to.
     */
    deactivateEventInfiniteLoader(blockContainer) {
        jQuery(blockContainer).parent().find('.plek-infinite-loader').remove();
    },

    get_text_from_ajax_request(data, only_success = false) {
        try {
            let encoded_data = JSON.parse(data);
            let text = "";
            if (encoded_data.success.length > 0) {
                text += encoded_data.success;
            }
            if (only_success) {
                return text; //End here, if only the success message should be returned.
            }
            if (encoded_data.error.length > 0) {
                text += (text.length === 0) ? '' : '<br/>';
                text += 'Error: ' + encoded_data.error;
            }
            if (encoded_data.system_error.length > 0) {
                text += (text.length === 0) ? '' : '<br/>';
                text += 'Error: ' + encoded_data.system_error;
            }
            return text;
        } catch (e) {
            return data;
        }

    },

    /**
     * Loads the content via ajax call
     * The container needs to have the class .plek-load-content and a data attribute "plek-content-loader"
     * Use the data attribute data-plek-content-params to send parameters as a json string
     */
    content_loader() {
        let items = jQuery('.plek-load-content');
        if (items.length == 0) {
            return;
        }
        jQuery(items).each(function (index) {
            var current_item = this;
            jQuery(current_item).html('<div class="plek-loading-content">' + __('Loading...', 'plekvetica') + '</div>');
            let do_load = jQuery(this).data('plek-content-loader');
            var button_id = jQuery(this).data('counter-button-id');
            let params = jQuery(this).data('plek-content-params');
            try {
                params = JSON.stringify(params);
            } catch (error) {
                console.error(error);
            }
            var send_data = new FormData();
            send_data.append('action', 'plek_content_loader');
            send_data.append('params', params);
            send_data.append('do', do_load);

            plek_main.send_form(send_data, this, 'content_loader_' + index, (r) => {
                const content = plek_main.get_success_item_from_ajax_request(r);
                const count = plek_main.get_success_item_from_ajax_request(r, 'count');
                jQuery(current_item).html(content);
                jQuery('#' + button_id).text(count);
            });
            return;
        });
    },

    /**
     * Sends a form via Ajax and handles the response with the given callbacks.
     * @param {FormData} form_data The form data to send.
     * @param {object|string} button The button that triggered the form submission. Id or object.
     * @param {string} form_id The ID of the form that was submitted.
     * @param {function} [success_callback] The callback to call on success. Default is `this.form_success_callback(response, button_id)`.
     * @param {function} [error_callback] The callback to call if there are errors in the response. Default is `this.form_error_callback(response, button_id, form_id)`.
     * @param {function} [systemerror_callback] The callback to call if there is an error with the Ajax request or response. Default is `this.form_systemerror_callback(response, button_id)`.
     * @param {object} attributes An object to pass to the success / error callback
     */
    send_form: async function (form_data, button, form_id, success_callback, error_callback, systemerror_callback, attributes = null) {
        if (this.request_already_sent('send_form_' + form_id)) {
            console.log('Form with ID:' + form_id + ' is still processing. Abort.');
            return;
        }
        this.register_request('send_form_' + form_id);
        if (button !== false) {
            if (empty(button)) {
                console.log('Please specify the button. ID or element');
                return;
            }
            if (empty(jQuery(button))) {
                console.log('No button ' + button + ' found');
                return;
            }
        }
        // Use default callbacks if not provided
        success_callback = success_callback || this.form_success_callback;
        error_callback = error_callback || this.form_error_callback;
        systemerror_callback = systemerror_callback || this.form_systemerror_callback;

        const button_text_loading = jQuery(button).data('text_loading') || null;
        const button_id = (typeof button === 'object') ? button.id : '0';
        plek_main.activate_button_loader(button, button_text_loading);
        plek_main.deactivate_button(button);
        plekerror.clear_field_errors();
        return await new Promise((resolve, reject) => {
            plek_main.send_form_ongoing[form_id + '_' + button_id] = jQuery.ajax({
                url: plek_vars.ajaxurl,
                type: 'POST',
                cache: false,
                processData: false,
                contentType: false,
                data: form_data,
                success: function success(response) {
                    const button_text = jQuery(button).data('text_default') || null;
                    plek_main.deactivate_button_loader(button, button_text);
                    plek_main.activate_button(button);
                    plek_main.unregister_request('send_form_' + form_id);

                    //Print the debug response
                    plek_main.print_response_debug(response);

                    //Response has errors. Trigger the error callback and exit the function
                    $errors = 0;
                    if (plek_main.response_has_errors(response)) {
                        error_callback(response, button, form_id, attributes);
                        $errors++;
                    }
                    if (plek_main.response_has_system_errors(response)) {
                        systemerror_callback(response, button, form_id, attributes);
                        $errors++;
                    }

                    if ($errors === 0) {
                        //No errors, calling the success callback
                        const success_response = success_callback(response, button, attributes);
                        resolve(success_response);
                    } else {
                        const normal_errors = plek_main.get_ajax_error_object(response);
                        const system_errors = plek_main.get_ajax_system_error_object(response);
                        reject({ errors: normal_errors, system_errors: system_errors });
                    }
                    return;
                },
                error: function error(response) {
                    if (response.statusText === 'abort') {
                        return; //On page reload or abort
                    }
                    console.log(response);
                    plek_main.unregister_request('send_form_' + form_id);
                    const system_error_response = systemerror_callback(response, button, form_id, attributes);
                    resolve(system_error_response);
                    return;
                }
            })
            return;
        });
    },
    /**
     * Sends a log via Ajax and logs the response in the console.
     * @param {FormData} form_data The form data to send.
     * @returns {Promise} A promise that resolves on success and rejects on error.
     */
    send_log: async function (form_data) {
        return await new Promise((resolve, reject) => {
            jQuery.ajax({
                url: plek_vars.ajaxurl,
                type: 'POST',
                cache: false,
                processData: false,
                contentType: false,
                data: form_data,
                success: function success(response) {
                    console.log(response);
                    return;
                },
                error: function error(response) {
                    console.log(response);
                    return;
                }
            })
            return;
        });
    },

    /**
     * Resets the button and shows the success message after a form was successfully submitted.
     * If the response contains a success message with key 'redirect', it redirects to the given URL or reloads the current page if the value is 'reload'.
     * @param {object|string} response - The response object from the AJAX call. Should contain success and message.
     * @param {string} button_id - The ID of the button that was clicked to trigger the form submission.
     * @param {object} attributes - The attributes for the callback. Null or object
     * @returns {string} The first success message
     */
    form_success_callback(response, button_id = null, attributes = null) {
        plek_main.form_success_actions(response, attributes);
        const first_response = plek_main.get_success_item_from_ajax_request(response);
        if (!empty(first_response) && first_response !== false) {
            plekerror.display_info(__('Success', 'plekvetica'), first_response);
        }
        return first_response;
    },

    /**
     * Performs actions based on the success messages in the response.
     * Currently supports:
     * - redirect: Redirects to the given URL or reloads the current page if the value is 'reload'.
     * @param {object|string} response - The response object from the Ajax request.
     * @param {object} attributes - The attributes for the callback. Null or object
     * @returns {boolean} False if there are no success messages or if the response is invalid JSON.
     */
    form_success_actions(response, attributes = null) {
        if (typeof response !== 'object') {
            if (!this.is_valid_JSON(response)) {
                return false;
            }
            response = JSON.parse(response);
            if (empty(response.success)) {
                return false;
            }
            Object.entries(response.success).forEach(([key, value]) => {
                switch (key) {
                    case 'redirect':
                        const delay = (!empty(response.success['delay'])) ? parseInt(response.success['delay']) : 0;

                        if (value === 'reload') {
                            setTimeout(() => {
                                window.location.reload(); //reload the current page
                            }, delay);
                            return;
                        }
                        setTimeout(() => {
                            window.location = value;//Redirects to page
                        }, delay);
                        break;
                    case 'insert_html':
                        try {
                            const items = JSON.parse(value);
                            if (jQuery('#' + items[0]).length > 0) {
                                jQuery('#' + items[0]).html(items[1]);
                            } else {
                                console.error('Failed to insert text for: ' + items[0] + ' - no element found');
                            }
                        } catch (error) {
                            console.error('Failed to insert text for: ' + value);
                            console.error(error);
                        }
                        break;
                    case 'overlay':
                        //Remove any old overlays
                        plektemplate.remove_overlay("response_overlay");
                        //Add the overlay
                        plektemplate.add_overlay("response_overlay", value);
                        plektemplate.show_overlay("response_overlay");
                        break;
                    default:
                        console.log('No action found for key: ' + key);
                        console.log(value);
                        break;
                }
            });
        }
        return;
    },

    /**
     * Default error callback for form submission. Shows a error message with a list of the validation errors.
     * @param {object} response - The response object from the Ajax request.
     * @param {string} button_id - The ID of the button that triggered the form submission.
     * @param {string} form_id - The ID of the form that was submitted.
     * @param {object} attributes - The attributes for the callback. Null or object
     */
    form_error_callback(response, button_id, form_id, attributes = null) {
        let form = document.getElementById(form_id);
        if (!empty(form)) {
            plekerror.show_errors_from_response(response, form, true);
            plekerror.scroll_to_first_error();
            return false;
        }
        plekerror.show_errors_from_response(response, '', true);
        return false;
    },

    /**
     * Default system error callback for form submission. Shows a fatal error message with a button to try again.
     * @param {object} response - The response object from the Ajax request.
     * @param {string} button_id - The ID of the button that triggered the form submission.
     * @param {object} attributes - The attributes for the callback. Null or object
     */
    form_systemerror_callback(response, button_id = null, attributes = null) {
        const system_errors = plek_main.get_ajax_system_error_object(response);
        if (empty(system_errors)) {
            plekerror.display_fatal_error(response);
            return false;
        }
        Object.entries(system_errors).forEach(([id, value]) => {
            plekerror.display_error(null, value, __('System Error', 'plekvetica'));
            return false;
        });
        return false;
    },

    /**
     * Perform a spellcheck on the given text field.
     * @param {string} target - The ID of the text field to spellcheck.
     * @param {string} button - The ID of the button that triggered the spellcheck.
     */
    async do_spellcheck(target, button) {
        let text = this.get_text_from_id(target) || '';
        if (empty(text)) {
            plekerror.display_error(null, __('Please enter some text', 'plekvetica'), __('Error', 'plekvetica'));
            return;
        }
        data = new FormData();
        data.append('action', 'plek_gpt_actions');
        data.append('do', 'spellcheck');
        data.append('text', text);
        data.append('security', plek_vars.plek_nonce);

        const result = await this.send_form(data, button, "", plektemplate.onSpellcheckerSuccess);
    },

    async send_message(button, subject = "", message = "") {

        data = new FormData();
        data.append('action', 'plek_notification_actions');
        data.append('do', 'send_message');

        const buttonData = jQuery(button).data();

        Object.entries(buttonData).forEach(([id, value]) => {
            data.append(id, value);
            console.log(id, value);
        });
        data.append('message', message);
        data.append('subject', subject);
        data.append('security', plek_vars.plek_nonce);

        return await this.send_form(data, button, "", plektemplate.onSendMessageSuccess);
    },

    /**
     * Returns the text content of a given element.
     * If the element is a TinyMCE editor, it uses the TinyMCE API to get the content.
     * Otherwise, it uses the jQuery val() method to get the value of the element.
     * @param {string} target - The ID of the element to get the text from.
     * @returns {string} The text content of the element.
     */
    get_text_from_id(target) {
        targetElement = target;
        if (typeof target === "string") {
            target = (target.charAt(0) === '#') ? target.substring(1) : target;
            targetElement = document.getElementById(target);
        }

        if (empty(targetElement)) {
            console.log("Element not found for ID:" + target);
            return '';
        }

        if (jQuery(targetElement).hasClass('wp-editor-area')) {
            const id = jQuery(targetElement).attr('id');
            if (typeof tinymce.editors[id] !== "undefined") {
                const is_visual = ((tinymce.editors[id].targetElm).getAttribute('aria-hidden') === 'true');
                if (is_visual) {
                    return tinymce.editors[id].getContent();
                } else {
                    return jQuery('#' + id).val();
                }
            }
            //If the tinymce is not initialized or if it is in html mode
            if (jQuery('#' + id).val().length > 0) {
                return jQuery('#' + id).val();
            }
        } else {
            return jQuery(targetElement).val();

        }
    },

    add_event_listener() {
        /** Ajax Loader button */
        jQuery('#page').on('click', '.ajax-block-loader-button', function (e) {
            e.preventDefault();
            plek_main.load_block(this);
        });

        /** Navi Search Button */
        jQuery('.plek-menu-search').on('click', 'a', function (e) {
            e.preventDefault();
            if (jQuery(".plek-menu-search input").val().length > 0) {
                plek_main.redirect_to_search(this);
            } else {
                jQuery(".plek-menu-search input").focus();
            }
        });
        /** Navi Search on enter key press */
        jQuery('.plek-menu-search input').keypress(function (e) {
            var keycode = (e.keyCode ? e.keyCode : e.which);
            if (keycode === 13) {
                plek_main.redirect_to_search(this);
            }
        });

        /* Navi Search Button accessibility workaround */
        jQuery('.plek-menu-search').on('focus', 'input', function (e) {
            jQuery(e.target).closest('ul').addClass('show-input');
        });
        jQuery('.plek-menu-search').on('focusout', 'input', function (e) {
            jQuery(e.target).closest('ul').removeClass('show-input');
        });

        /** Toggle Notifications container */
        jQuery('#main').on('click', '#notifications-button', function (e) {
            plek_main.toggle_notification_container(this);
        });

        /** Dismiss Notification */
        jQuery('#notifications-container').on('click', '.dismiss_notification', function (e) {
            plek_main.dismiss_notification(this);
        });

        /** Change Upload Button Text and show Image */
        jQuery("input[type='file']").not('#review_images').change(function () {
            plek_main.image_upload_button_change(this);
        });

        /** Postloader click action */
        jQuery(".postloader-button").click(function () {
            plek_main.on_postloader_button_click(this);
        });

        /** Value switcher click action */
        jQuery(document).on('click', '.value-switcher', (function () {
            plek_main.switch_value(this);
        }));

        /** Image downloader */
        jQuery(document).on("click", '.plek-download-images', function (e) {
            e.preventDefault();
            plek_main.get_galleries_download_url(this);
        });

        /** button dropdown mobile fix */
        jQuery(document).on("click", '.plek-button-dropdown i', function (e) {
            plek_main.toggle_button_dropdown(this);
        });

        /** Confirm Button trigger */
        jQuery(document).on("click", '.plek-button-confirm button', function (e) {
            e.preventDefault();
            plek_main.triggerConfirmButton(e);
        });

        /** Send message button */
        jQuery(document).on("click", 'button.notification_action', async function (e) {
            e.preventDefault();
            let request_preview = jQuery(e.target).data('request_preview');
            const language = jQuery(e.target).data('plek_language');
            const recipient_id = jQuery(e.target).data('recipient_id');
            const recipient_email = jQuery(e.target).data('recipient_email');
            const has_recipient = ((parseInt(recipient_id) > 0) || (!empty(recipient_email) && recipient_email !== 'unset')) ? true : false;

            if (!has_recipient) {
                request_preview = 'true';
                jQuery(e.target).data('request_preview', 'true')
            }
            if (request_preview === 'prompt') {
                if (confirm(__('Do you want to get a preview before sending?', 'plekvetica'))) {
                    jQuery(e.target).data('request_preview', 'true');
                } else {
                    jQuery(e.target).data('request_preview', 'false');
                }
            }
            if (language === 'prompt') {
                const prompt_language = plek_lang.prompt_language();
                if (!empty(prompt_language)) {
                    jQuery(e.target).data('plek_language', prompt_language);
                } else {
                    //Do noting if language not confirmed
                    return;
                }
            }
            await plek_main.send_message(this);
            //reset the request preview and language
            jQuery(e.target).data('request_preview', request_preview);
            jQuery(e.target).data('plek_language', 'prompt');
        });

        /** Send edited message button */
        jQuery(document).on("click", 'button.notification_action_send', function (e) {
            e.preventDefault();
            const message = plek_main.get_text_from_id('preview_email_content');
            const subject = plek_main.get_text_from_id('email_subject');
            const recipient = plek_main.get_text_from_id('email_recipient');
            jQuery(e.target).data('recipient_email', recipient);
            plek_main.send_message(this, subject, message);
        });

        plek_main.infiniteScroll();

        //Show the remaining text to enter
        jQuery(document).on('input', 'textarea[maxLength]', (e) => {
            plek_main.showTextareaCharacters(e.currentTarget);
        });

        //Toggle containers with the toggle attribute
        jQuery(document).on('click', '[data-action="toggle_container"]', (e) => {
            plek_main.toggle_containers(e.currentTarget);
        });

        window.addEventListener('beforeunload', () => {
            plek_main.abort_send_forms();
        });
        jQuery(document).on('heartbeat-tick', function (event, data) {
            plek_main.processHeartbeat(event, data);
        });
        jQuery(document).on('click', '.post_takeover_action', function (event) {
            plek_main.postTakeoverAction(event.target);
        });
    },

    /**
     * Abort all ongoing send_form requests. This is called on window.unload to prevent requests from being sent when the page is closed.
     *
     */
    abort_send_forms() {
        const sended = Object.entries(plek_main.send_form_ongoing);
        sended.forEach(([index, request]) => {
            request.abort();
        });
    },


    /**
     * Toggles the dropdown on mobile
     * 
     * @param {dom} element Dom element
     */
    toggle_button_dropdown(element) {
        if (jQuery(element).closest('span').next().css('display') === 'flex') {
            jQuery(element).closest('.plek-button-dropdown').find('span:not(:first-child)').css('display', 'none');
        } else {
            jQuery(element).closest('.plek-button-dropdown').find('span:not(:first-child)').css('display', 'flex');
        }
    },

    /**
     * Changes the Text of the upload button as soon as the file got selected.
     * @param {object} item The Upload input
     */

    image_upload_button_change(item) {
        let text = (!empty(jQuery(item).data('selected-text'))) ? jQuery(item).data('selected-text') : __('File selected', "plekvetica");
        var upload = jQuery(item).prop("files")[0];
        var id = jQuery(item).attr("id");
        if (typeof upload === "object") {
            //File has been uploaded
            if (upload.type.search("image/") === 0) {
                //File is type image
                //Display the Image on screen
                const reader = new FileReader();
                reader.onload = function (e) {
                    jQuery('#' + id + '-image img').attr('src', e.target.result);
                }
                this.get_image_dimensions(upload, (width, height) => {
                    if (plek_main.event_poster_min_dimensions.width > width || plek_main.event_poster_min_dimensions.height > height) {
                        const info = __('The uploaded image is smaller that the recommended size of %s1 x %s2px. We recommend to upload a larger picture.', 'plekvetica');
                        plekerror.display_info(__('Warning', 'plekvetica'),
                            info.replace('%s1', plek_main.event_poster_min_dimensions.width).replace('%s2', plek_main.event_poster_min_dimensions.height)
                        );
                    }
                });
                reader.readAsDataURL(upload);
            }
            jQuery(item).next(".plek-button").text(text); //Change the Button Text
        }
    },

    /**
     * 
     * @param {object} file The uploaded file
     * @param {object} callback The width and height as a callback function
     */
    get_image_dimensions(file, callback) {
        const img = new Image();
        const url = URL.createObjectURL(file);
        img.onload = function () {
            const width = img.width;
            const height = img.height;

            URL.revokeObjectURL(url);
            callback(width, height);
        };
        img.src = url;
    },

    /**
 * Loads the Preview Image to a dom element
 * @param {dom} dom_element - The dom element to add the image to.
 * @param {object} file_upload - The uploaded file 
 * @returns 
 */
    get_preview_image(dom_element, file_upload) {
        if (typeof file_upload === "object") {
            //File has been uploaded
            if (file_upload.type.search("image/") === 0) {
                //File is type image
                //Display the Image on screen
                var reader = new FileReader();
                reader.onload = function (e) {
                    if (jQuery(dom_element).nodeName !== "IMG") {
                        jQuery(dom_element).find('img').attr('src', e.target.result);
                    } else {
                        jQuery(dom_element).attr('src', e.target.result);
                    }
                }
                reader.readAsDataURL(file_upload);
                return true;
            }
        }
        return false;

    },

    /**
     * 
     * @param {object} search - This should be the Button/A Tag or the input field 
     * @returns 
     */
    redirect_to_search(search) {
        if (search.nodeName === 'INPUT') {
            var search_for = jQuery(search).val();
        } else {
            var search_for = jQuery(search).parent().find('input').val();
        }
        let url = window.location.protocol + '//' + window.location.hostname + '?s=' + search_for;
        window.location.replace(url);
        return;
    },

    /**
     * Redirects to another page with an additional timeout
     * @param {string} url 
     * @param {int} timeout 
     * @returns 
     */
    redirect_to_url(url, timeout = 0) {
        setTimeout(() => {
            window.location.replace(url);
        }, timeout);
        return;
    },


    /**
     * Retrieves the success data from the Ajax response.
     * 
     * @param {object|string} data - The Ajax response, either as an object or a JSON string.
     * @returns {array|object|false} The success data if available, or false if it cannot be parsed.
     */

    get_ajax_success_object(data) {
        try {
            let encoded_data = (typeof data === "object") ? data : JSON.parse(data);
            if (encoded_data.success.length > 0) {
                return encoded_data.success;
            }

        } catch (e) {
            console.warn("Data could not converted into JSON data at get_ajax_success_object()");
            return false;
        }
    },
    /**
     * Tries to get the System Error from the Ajax Response.
     * If the Data is not a valid JSON string, it will return the original data.
     * @param {object|string} data - The Ajax response. As object or string.
     * @returns false|array The System Error(s) of the Ajax response, or false if the encoding failed
     */
    get_ajax_system_error_object(data) {
        try {
            let encoded_data = (typeof data === "object") ? data : JSON.parse(data);
            if (encoded_data.system_error.length > 0) {
                return encoded_data.system_error;
            }

        } catch (e) {
            console.warn("Data could not converted into JSON data at get_ajax_system_error_object()");
            return false;
        }
    },

    /**
     * Retrieves the error data from the Ajax response.
     * 
     * @param {object|string} data - The Ajax response, either as an object or a JSON string.
     * @returns {array|false} The error data if available, or false if the encoding failed
     */

    get_ajax_error_object(data) {
        try {
            let encoded_data = (typeof data === "object") ? data : JSON.parse(data);
            if (encoded_data.error.length > 0) {
                return encoded_data.error;
            }

        } catch (e) {
            console.warn("Data could not converted into JSON data at get_ajax_error_object()");
            return false;
        }
    },

    /**
     * Gets the first error of the ajax response
     * @param {object} data 
     * @returns 
     */
    get_first_error_from_ajax_request(data) {
        try {
            let encoded_data = (typeof data === "object") ? data : JSON.parse(data);
            let text = "";
            if (encoded_data.error.length > 0) {
                text += encoded_data.error[0];
            }
            return text;
        } catch (e) {
            return data;
        }

    },

    /**
     * Gets the first error of the ajax response
     * @deprecated 5.8.1 Use get_success_item_from_ajax_request() instead
     * @param {object} data 
     * @returns 
     */
    get_first_success_from_ajax_request(data) {
        if ((typeof data !== "object")) {
            if (!plek_main.is_valid_JSON(data)) {
                console.log(data);
                return __('Success, but no return value', 'plekvetica');
            }
            data = JSON.parse(data);
        }
        if (empty(data.success)) {
            return false;
        }
        const first_key = Object.keys(data.success)[0];
        return data.success[first_key];
    },

    /**
     * Gets the result from the ajax response.
     * 
     * @param {object|string} data The Ajax response. As object or string.
     * @param {int} array_index The Index to return. Default: message
     * @returns string The Value of the array at index position.
     */
    get_success_item_from_ajax_request(data, array_index = 'message') {
        try {
            let encoded_data = (typeof data === "object") ? data : JSON.parse(data);
            if (typeof encoded_data.success[array_index] !== 'undefined') {
                return encoded_data.success[array_index];
            } else {
                return false;
            }
            return text;
        } catch (e) {
            console.log(e);
            return false;
        }

    },


    /**
     * Workaround for unchecked checkboxes.
     * Checks all checkboxes in the form and adds them to the formdata.
     * @param {object} data The formdata object.
     * @param {string} form_id The id of the form.
     * @returns {object} The formdata object with the checkboxes added.
     */
    get_checkbox_inputs(data, form_id) {
        //Workaround for unchecked checkboxes
        const checkboxes = document.querySelectorAll('#' + form_id + ' input[type="checkbox"]');
        checkboxes.forEach(checkbox => {
            // Check if the checkbox is not included in formData
            if (!data.has(checkbox.name)) {
                // Add checkbox state (false or true if checked)
                data.append(checkbox.name, checkbox.checked ? checkbox.value : 'no');
            }
        });
        return data;
    },

    /**
     * Checks if a ajax response has errors.
     * 
     * @param {object|string} data - The data from the plekvetica ajax request.
     * @returns bool|null true if errors exists, false if no errors, null if data is empty
     */
    response_has_errors(data) {
        try {
            if (empty(data)) {
                return null;
            }
            var encoded_data = data;
            if (typeof data !== 'object') {
                encoded_data = JSON.parse(data);
            }
            if (encoded_data.error.length === 0) {
                return false;
            }
            return true;
        } catch (e) {
            console.log(e);
            return true;
        }
    },
    /**
     * Checks if a ajax response has system errors.
     * 
     * @param {object|string} data - The data from the plekvetica ajax request.
     * @returns bool|null true if system errors exists, false if no system errors, null if data is empty
     */
    response_has_system_errors(data) {
        try {
            if (empty(data)) {
                return null;
            }
            var encoded_data = data;
            if (typeof data !== 'object') {
                encoded_data = JSON.parse(data);
            }
            if (encoded_data.system_error.length === 0) {
                return false;
            }
            return true;
        } catch (e) {
            console.log(e);
            return true;
        }
    },
    /**
     * Prints the debug information of a ajax response to the console.
     * Only works if the response is a valid JSON string and contains a 'debug' property.
     * @param {string|object} data The Ajax response. As object or string.
     * @returns {void}
     */
    print_response_debug(data) {
        if (plek_main.is_valid_JSON(data)) {
            const encoded_data = JSON.parse(data);
            if (!empty(encoded_data.debug)) {
                console.table(encoded_data.debug);
            }
        }
        return;
    },

    /**
     * Displays the form field errors
     * @deprecated Replaced by plekerror.show_errors_from_response()
     * @param {string|object} data The Error Object or Json String
     * @param {string} form The Form ID
     * @param {bool} display_unassigned_as_toastr Set to true if the unassigned errors should be displayed as a toastr message.
     * @returns 
     */
    show_field_errors(data, form = 'form', display_unassigned_as_toastr = true) {

    },

    show_non_field_error(selector, message) {
        jQuery(selector).after(plek_main.format_error_message(message));
    },

    /**
     * Checks if a string is valid JSON
     * @param {string} data The string to check
     * @return {bool} True if valid JSON, false otherwise
     */
    is_valid_JSON(data) {
        try {
            JSON.parse(data);
            return true;
        } catch (error) {
            return false;
        }
    },

    format_error_message(msg) {
        return `<span class="plek-error plek-field-error">${msg}</span>`;
    },

    /**
     * Gets the block content with a ajax request
     * @todo: Add Function to autoload a block content.
     * @param {object} button 
     */
    load_block(button) {
        let container = jQuery(button).closest('.block-container');
        const only_data_from_url = jQuery(button).attr('data-only-from-url');

        if (empty(container) || container.length === 0) {
            //Fallback. If no closest found, search the whole dom. if more than one is found, it will return a error
            container = jQuery('.block-container');
            if (container.length > 1) {
                console.error("More than one block container found");
                return false;
            }
        }
        //this.default_values.original_document_title = document.title;
        plekerror.clear_field_errors();

        //let button = jQuery('.plek-follow-band-btn');
        plek_main.activate_loader_style(button);
        var send_data = new FormData();
        send_data.append('action', 'plek_event_actions');
        send_data.append('do', 'load_block_content');
        //if(only_data_from_url !== 'true'){
        send_data = plek_main.get_block_data(container, send_data, button);
        //}
        send_data = plek_main.get_url_query_data(send_data);

        const block_id = (!empty(button.dataset) && !empty(button.dataset.block_id)) ? button.dataset.block_id : ''
        plek_main.send_form(send_data, button, block_id,
            this.load_block_success, false, false, { container: container, send_data: send_data });
    },

    /**
     * Replaces the content of the container with the response from the ajax request.
     * @param {object} response The response from the ajax request.
     * @param {object} button The button that triggered the form submission.
     * @param {object} attributes An object with the following properties:
     * - send_data: The formdata of the form that was submitted.
     * - container: The container element that should be replaced.
     */
    load_block_success(response, button, attributes) {

        const send_data = !empty(attributes['send_data']) ? attributes['send_data'] : null;
        const container = !empty(attributes['container']) ? attributes['container'] : null;
        const text = plek_main.get_success_item_from_ajax_request(response);
        if (empty(send_data) || empty(container)) {
            console.error('Missing send_data or container');
            return;
        }
        //Replace all the container content
        jQuery(container).replaceWith(text);
        //Set the new URL and Title
        let page = send_data.get('paged');
        let block_id = send_data.get('block_id');
        let past_events = send_data.get('get_events');
        if (page) {
            window.history.pushState({}, "Page", plek_main.url_add_page(page, block_id, send_data, past_events));
            //document.title = plek_main.default_values.original_document_title + ' - Page '+page;
            plek_main.scroll_to_block(block_id);

        }

        if (button.id === 'apply_filter') {
            jQuery('#event-filter-container').removeClass('show');
        }
    },

    /**
     * Gets the block data from the container out of the html-data attributes.
     * @param {object} container 
     * @param {object} formdata 
     * @param {object} button 
     * @returns 
     */
    get_block_data(container, formdata, button, ignore_items = []) {
        if (empty(ignore_items)) {
            //Ignores the filter parameters. This way it only gets the filters from the url. If set
            ignore_items = ['filter_genres', 'filter_countries', 'filter_start_date', 'filter_end_date', 'filter_featured', 'filter_giveaway', 'search']
        }

        for (let [id, val] of Object.entries(jQuery(container).data())) {
            if (ignore_items.indexOf(id) >= 0) {
                continue;
            }

            if (id === 'block_id' && val === 'all_events' && jQuery(button).data('paged') === 1 && jQuery(button).parent().hasClass('pagination-prev')) {
                //Workaround to load the results form the first page
                formdata.append('first_page', true);
            }
            if (id !== 'paged') {
                formdata.append(id, val);
            }
        }
        let paged = jQuery(button).data('paged');
        paged = empty(paged) ? 1 : paged;
        formdata.append('paged', paged);


        return formdata;
    },

    /**
     * Gets the parameters out of the url.
     * @param {object} formdata 
     * @returns 
     */
    get_url_query_data(formdata, items = ['order', 'direction', 's', 'search_reviews', 'filter_genres', 'filter_countries', 'filter_start_date', 'filter_end_date', 'filter_featured', 'filter_giveaway', 'search']) {
        let url = new URLSearchParams(window.location.search);
        jQuery(items).each(function (id, name) {
            let val = url.get(name);
            //Check if parameter already exists
            if (formdata.get(name) !== null && formdata.get(name) === val) {
                //Ignore if value is already existing
                return;
            }
            if (val !== null && val.length > 0) {
                formdata.append(name, val)
            }
        });
        return formdata;
    },

    /**
     * Adds the page and block id to the current url and returns the url.
     * @param {int} page_number 
     * @param {string} block_id 
     * @param {object} send_data - The sended data 
     * @returns The current url with page and block_id parameters
     * @todo: use the send_data data to add them to the url. But filter first...
     */
    url_add_page(page_number, block_id, send_data) {
        var url_object = new URLSearchParams(window.location.search);
        let base = window.location.pathname;
        let query = window.location.search;
        let new_url = '';
        var separator = (query.indexOf('?') === -1) ? '?' : '&';

        if (base.search('page/') > 0) {
            new_url = base.replace(/(page\/[0-9]+)/, 'page/' + page_number);
        } else {
            if (page_number !== "undefined") {
                new_url = base + '/page/' + page_number;
                new_url = new_url.replace('//', '/', base + '/page/' + page_number);
            } else {
                //No page number defined
                new_url = base;
            }
        }
        new_url += query;
        /** Add the block id */
        if (query.search('block_id=') > 0) {
            new_url = new_url.replace(/block_id=([A-z0-9_-]*)/, 'block_id=' + block_id);
        } else {
            new_url = new_url + separator + 'block_id=' + block_id;
        }

        /** Add the search query, if not existing */
        if (url_object.get('s') !== null && query.search('s=') === 0) {
            new_url = new_url + separator + 's=' + url_object.get(s);
        }
        return new_url;
    },

    /**
     * 
     * @param {string} param - Name of the Parameter to replace or add
     * @param {string} value - The value of the parameter
     * @param {bool} update_ur - If the Function updates the current url or not
     * @returns 
     */
    url_replace_param(param, value, update_url = true) {
        let query = window.location.search;
        if (query.indexOf(param + '=' + value) > 0) {
            //This parameter is already set with the same value.
            return window.location.origin + window.location.pathname + query;
        }
        let regex = new RegExp(param + "=([A-z0-9_-]*)");
        let new_query = query.replace(regex, param + '=' + value);
        if (query === new_query) {
            //Could not replace the param, try to add
            let separator = (query.indexOf('?') === -1) ? '?' : '&';
            new_query = query + separator + param + "=" + value;
        }
        let new_url = window.location.origin + window.location.pathname + new_query;
        if (update_url) {
            this.update_browser_url(new_url, document.title);
        }
        return new_url;
    },

    /**
     * Sets the browser url and title
     * 
     * @param {string} url The new URL
     * @param {string} title The Title of the document
     * @returns 
     */
    update_browser_url(url, title) {
        //Change the URL
        window.history.pushState({}, title, url);
        //Update the title
        document.title = title;
        return;
    },
    /**
     * Scroll to the top of the reloaded current block.
     * @param {string} block_id 
     */
    scroll_to_block(block_id) {
        try {
            let position = jQuery('.block-' + block_id).offset().top;
            jQuery('html').animate({
                scrollTop: position - 110
            }, 800);
        } catch (e) {
            console.log("Block: " + block_id + " not found in container");
        }
    },

    /**
     * Toggles the visibility of the notification container
     * @param {*} item 
     */
    toggle_notification_container(item) {
        if (jQuery('#notifications-container').is(':hidden')) {
            jQuery('#notifications-container').show(100, function () {
                //Check for click event outside of the container. if detected, close the container.
                jQuery('body').on('click', function (event) {
                    if (!jQuery(event.target).closest('#notifications-container').length) {
                        jQuery('#notifications-container').hide(100);
                        jQuery('body').off('click');
                    }
                });
            });
        } else {
            jQuery('#notifications-container').hide(100);
        }
    },
    /**
     * Dismisses a Notification
     * @param {*} item 
     */
    dismiss_notification(item) {
        if (empty(item)) {
            console.error('No item given');
            return false;
        }

        var dismiss_id = jQuery(item).data('dismiss-id');
        if (empty(dismiss_id)) {
            console.error('No dismiss ID given');
            return false;
        }

        jQuery(item).find('i').removeClass('fa-times');
        jQuery(item).find('i').addClass('fa-spinner');

        var send_data = new FormData();
        send_data.append('action', 'plek_user_actions');
        send_data.append('do', 'dismiss_notification');
        send_data.append('dismiss_id', dismiss_id);

        plek_main.send_form(send_data, item, 'dmc', function (response, button, attributes) {
            const dismiss_id = !empty(attributes['dismiss_id']) ? attributes['dismiss_id'] : false;
            if (dismiss_id !== false) {
                jQuery('#notification_' + dismiss_id).addClass('dismissed');
            } else {
                console.error('No dismiss ID given');
            }
        }, false, false, { dismiss_id: dismiss_id });
    },

    /**
     * Removes all the inputs within the given form id.
     * @param {string} form_id 
     */
    clear_form_inputs(form_id) {
        let form = jQuery('#' + form_id);
        if (empty(form)) {
            return false;
        }
        //Clear all the Input fields
        form.find('input').each((id, item) => {
            jQuery(item).val('');
        });
        //Clear all the textarea fields
        form.find('textarea').each((id, item) => {
            let textarea_id = jQuery(item).attr('id');
            if (!empty(tinymce.get(textarea_id))) {
                tinymce.get(textarea_id).setContent('');
            }
            jQuery(item).val(''); //Fallback if no wp editor
        });
        //Clear all the textarea fields
        form.find('select').each((id, item) => {
            jQuery(item).val('').trigger('change');
        });

        //On band Inputs
        if (form_id === 'plek-band-form') {
            jQuery("#video_preview_con").html("");
            this.reset_file_inputs(form_id);
            //Reset the spotify data
            plek_band.spotify_bands_found = null;
        }

        //Clear all the tomselect inputs
        jQuery('#' + form_id + ' select.tomselect').each((index, item) => {
            item.tomselect.clear();
            item.tomselect.setValue('NULL'); //Set the value null if this option exists
        });
        return true;
    },

    /**
     * Inserts the given text into the TinyMCE editor identified by editor_id
     * 
     * @param {string} editor_id - The id of the TinyMCE editor
     * @param {string} text - The text to insert. If empty string, the cursor will be moved to the end of the content
     * 
     * @returns void
     */
    insert_text_wp_editor(editor_id, text = "") {
        // Get the TinyMCE editor instance
        var editor = tinymce.get(editor_id);

        if (editor) {
            editor.focus();
            var bookmark = editor.selection.getBookmark();
            editor.selection.moveToBookmark(bookmark);
            editor.execCommand('mceInsertContent', false, text);
        } else {
            console.error('Editor not found');
        }
    },

    /**
     * Resets the file inputs and replaces the selected image with the placeholder.
     * @param {string} form_id 
     */
    reset_file_inputs(form_id) {
        //Empty the file input
        jQuery('#'.form_id).find('input[type=file]').each((id, item) => {
            jQuery(item).val(null);
        });
        //Restore the placeholder file
        let placeholder = document.plek_home_url + '/wp-content/plugins/plekvetica/images/placeholder/default_placeholder.jpg';
        jQuery('#' + form_id).find('.plek-image-upload-container').find('img').first().attr('src', placeholder);

        //Reset the Button text
        jQuery('#' + form_id).find('.plek-image-upload-container').find('.plek-button').text(__('Upload', 'plekvetica'));

    },

    /**
     * Converts the timestamp to the desired date format
     * @param {string} timestamp The Timestamp in Seconds (eg. from PHP)
     * @param {string} format The format to return
     * @returns String The date without timezone or false if not timestamp received
     */
    get_formated_date(timestamp, format = '', fix_timezone = true) {

        var length = format.length;
        if (length === 0) {
            return '';
        }
        if (empty(timestamp)) {
            return false;
        }

        var formated_date = '';
        let pieces = Array.from(format);
        jQuery(pieces).each((index, item) => {
            let js_date = new Date(timestamp * 1000);
            //Timezone fix
            let time = js_date.getTime();
            let offset = js_date.getTimezoneOffset() * 60000;
            if (fix_timezone) {
                var fixed_js_date = new Date(time + offset);
            } else {
                var fixed_js_date = new Date(time);
            }
            //let fixed_js_date = js_date; //Don't fix the timezone offset

            switch (item) {
                case 'H':
                    var timepiece = '0' + fixed_js_date.getHours();
                    timepiece = timepiece.slice(-2);
                    break;
                case 'i':
                    var timepiece = '0' + fixed_js_date.getMinutes();
                    timepiece = timepiece.slice(-2);
                    break;
                case 's':
                    var timepiece = '0' + fixed_js_date.getSeconds();
                    timepiece = timepiece.slice(-2);
                    break;
                case 'd':
                    var timepiece = '0' + fixed_js_date.getDate();
                    timepiece = timepiece.slice(-2);
                    break;
                case 'm':
                    var timepiece = '0' + (fixed_js_date.getMonth() + 1);
                    timepiece = timepiece.slice(-2);
                    break;
                case 'Y':
                    var timepiece = fixed_js_date.getFullYear();
                    break;

                default:
                    timepiece = item;
                    break;
            }
            formated_date = formated_date + timepiece;
        });

        return formated_date;
    },
    /**
     * Checks if the current page contains a edit / add event form 
     * 
     * @returns bool True if page contains a even form, false otherwise
     */
    page_has_event_form() {
        if (!empty(jQuery('#edit_event_form')) || !empty(jQuery('#add_event_basic')) || !empty(jQuery('#add_event_login')) || !empty(jQuery('#add_event_details'))) {
            return true;
        }
        return false;
    },
    /**
     * Checks if the current page contains a login / lost-password event form 
     * 
     * @returns bool True if page contains a even form, false otherwise
     */
    page_has_login_form() {
        if (!empty(jQuery('#register-new-user-form')) || !empty(jQuery('#loginform')) || !empty(jQuery('#lostpasswordform')) || !empty(jQuery('#set_new_password_form'))) {
            return true;
        }
        return false;
    },

    /**
     * Sends a ajax request to the codetester ajax function
     * @param {string} data The data to send for the test
     */
    ajax_codetester(data = null) {

        var send_data = new FormData();
        send_data.append('action', 'plek_ajax_codetester_actions');
        send_data.append('data', data);
        plek_main.send_form(send_data, false);
    },

    /**
     * Loads the content that will be loaded after the page is ready
     */
    do_postloader() {
        const items = jQuery('.ajax-postloader');
        const preload = Array.from(items).map(async (item, index) => {

            const button = jQuery(item);
            const action = button.data('action');
            const action_do = button.data('do');
            const id = button.data('id');

            if (empty(button) || empty(action) || empty(action_do) || empty(id)) {
                console.error('Button, action, action_do or id is missing from postloader');
                return false;
            }

            const formdata = new FormData();
            formdata.append('action', action);
            formdata.append('do', action_do);
            formdata.append('id', id);
            return await plek_main.send_form(formdata, button, id, (response, button) => {
                const button_id = button[0].id || false;
                if (!button_id) {
                    console.error("No button ID found, unable to add content from postloader");
                    return false;
                }
                plek_main.postloader_content[button_id] = plek_main.get_success_item_from_ajax_request(response);
                //Activate the button
                jQuery(button).removeAttr("disabled");
                jQuery(button).removeClass("ajax-postloader");
                return true;
            });

        }); //End Array.from
    },
    /**
     * Action if a postloader button is clicked
     * @param {object} element 
     */
    on_postloader_button_click(element) {
        if (jQuery(element).attr('disabled') === 'disabled') {
            return;
        }
        const target = jQuery(element).data('target');
        const id = jQuery(element).attr('id');

        if (empty(plek_main.postloader_content[id])) {
            console.log("Error loading postloaded content. No content found");
            return;
        }
        const content = plek_main.postloader_content[id];
        const popup = new plekPopup;
        if (target === 'popup') {
            popup.showPopup(content, id);
        }
    },
    switch_value(element) {
        let status = jQuery(element).val();
        const type = jQuery(element).attr('type');
        const target = jQuery(element).data('target-id');
        let text = '';
        if (type === 'checkbox') {
            const checked = element.checked;
            if (!checked) {
                status = 'default';
            }
        }

        //try to switch the value
        text = jQuery(`#${target}`).data(`${status}-text`);
        jQuery(`#${target}`).html(text);
    },

    /**
     * Checks if a request is already sent
     * @param {string} id 
     * @returns 
     */
    request_already_sent(id) {
        if (!empty(this.request_sent[id])) {
            return true;
        };
        return false;
    },

    /**
     * Adds the ID to the request sent parameter
     * @param {string} id 
     */
    register_request(id) {
        this.request_sent[id] = true;
    },

    /**
     * Adds the ID to the request sent parameter
     * @param {string} id 
     */
    unregister_request(id) {
        delete this.request_sent[id];
    },


    /**
     * Downloads the given url
     * @param {string} url 
     */
    download_file(url) {
        window.open(url, '_self');
    },
    /**
     * Gets the decoded filename of an url
     * @param {string} url The url
     * @returns string
     */
    get_filename_from_url(url) {
        const filename = url.substring(url.lastIndexOf('/') + 1);
        return decodeURIComponent(filename);
    },

    /**
 * Gets the url to the zipped album images
 * @param {button} element The button
 */
    get_galleries_download_url(element) {
        let button = jQuery(element);
        let gallery_ids = button.data('gallery_ids');

        plek_main.activate_loader_style(button);

        var data = new FormData();
        data.append('action', 'plek_ajax_gallery_actions');
        data.append('do', 'get_images_download_link');
        data.append('gallery_ids', gallery_ids);

        this.send_form(data, button, 'download_galleries', (response) => {
            const url = plek_main.get_success_item_from_ajax_request(response);
            //Add url to console
            console.log(url);
            plek_main.download_file(url);
        });
    },
    /**
     * Generates the url with the parameter of the filter
     * @returns string
     */
    url_add_filter(data = {}, return_absolute = false) {
        var url_object = new URLSearchParams(window.location.search);
        let base = window.location.pathname;
        let query = window.location.search;
        let new_url = query;
        if (empty(data)) {
            //Collect the data
            try {
                data = document.event_filter.get_filter_data(true);
            } catch (error) {
                console.log(error);
                return;
            }
        }
        for (let key in data) {
            let separator = (new_url.indexOf('?') >= 0) ? '&' : '?';
            let val = data[key];
            if (empty(val)) {
                //remove the parameter if value is empty
                const regex = new RegExp('([?&]{1})' + key + '=([A-z0-9,:_%-]*)');
                new_url = new_url.replace(regex, '');
                continue;
            }
            //Puts the objects together into a string
            if (typeof val === 'object') {
                val = val.join('_');
            }
            //Checks if the parameter already exists. If so, it will be replaced with the new value
            if (query.search(key + '=') > 0) {
                const regex = new RegExp(key + '=([A-z0-9,:_%-]*)');
                new_url = new_url.replace(regex, key + '=' + encodeURIComponent(val));

            } else {
                //Parameter does not exist, will be added at the end
                new_url = new_url + separator + key + '=' + encodeURIComponent(val);
            }
        }

        if (return_absolute) {
            //Fix the base
            if (base.indexOf('&') >= 0) {
                const split_base = base.split('&');
                base = split_base[0];
            }
            return window.location.protocol + '//' + window.location.hostname + base + new_url;
        }
        return new_url;
    },

    /**
    * Adds the TomSelect to applicable items
    */
    initTomSelect() {
        const tomSelectDefaultSettings = {
            plugins: {
                change_listener: {}
            },
            maxOptions: 250
        };
        const tomSelectMultipleSettings = {
            plugins: {
                change_listener: {},
                remove_button: {
                    title: 'Remove this item',
                }
            },
            onItemAdd: function (value, item) {
                // Clear input text - this behavior is handled by the library automatically
            },
            onDropdownClose: function (dropdown) {
                // The dropdown will close automatically after selection
            },
            maxOptions: 250
        };
        jQuery('select.tomselect').each((id, item) => {
            if (!empty(item.tomselect)) {
                return; //Skip when tomselect is already initialized
            }
            let settings = tomSelectDefaultSettings;
            if (jQuery(item).prop('multiple')) {
                settings = tomSelectMultipleSettings;
            }
            const ts = new TomSelect(jQuery(item), settings);
            //Get the original aria-label and set it to the new input
            const orig_label = item.getAttribute('aria-label');
            ts.control_input.setAttribute('aria-label', orig_label);
        });
    },

    /**
     * Sets a value for a tomselect input field
     * 
     * @param {string|object} item The items to apply the value change on
     * @param {string} value The value to set
     */
    tomSelectSetVal(item, value) {
        if (typeof item === 'string') {
            item = document.querySelectorAll(item);
        }
        jQuery(item).each((index, element) => {
            if (!empty(element.tomselect)) {
                element.tomselect.setValue(value);
            }
        });
    },

    infiniteScroll() {

        let element = jQuery('.infinite-scroll > .block-container:last-child > *:nth-last-child(4)');

        plek_main.infinite_scroll_observer = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) {
                plek_main.infinite_scroll_observer.unobserve(element[0]); //Reset the observer
                const parent = jQuery(element).parent('.block-container');
                if (!empty(plekevent) && !empty(parent)) {
                    plekevent.doInfiniteScroll(parent);
                }
            }
        }, {
            rootMargin: '0px',
            threshold: 1.0
        });

        //Start observing
        if (!empty(element[0])) {
            plek_main.infinite_scroll_observer.observe(element[0]);
        }
    },

    /**
     * Handles the confirmation button actions based on the button class.
     * 
     * @param {object} element - The DOM element that triggered the action.
     * 
     * If the button has class 'trigger-activate', it activates the confirmation UI.
     * If the button has class 'trigger-cancel', it deactivates the confirmation UI.
     * If the button has class 'confirm-action', it sends a form with specified actions.
     * Displays an error if no actions are defined for the button.
     */

    triggerConfirmButton(element) {
        const button = jQuery(element.currentTarget);
        if (button.hasClass('trigger-activate')) {
            button.parent().closest('.plek-button-confirm').addClass('active');
            button.parent().closest('.plek-button-confirm').removeClass('not-active');
        }
        if (button.hasClass('trigger-cancel')) {
            button.parent().closest('.plek-button-confirm').addClass('not-active');
            button.parent().closest('.plek-button-confirm').removeClass('active');
        }
        if (button.hasClass('confirm-action')) {

            const button_data = button.data();
            const data = new FormData();
            Object.entries(button_data).forEach(([key, value]) => {
                data.append(key, value);
            });
            if (data.has('action')) {
                this.send_form(data, button);
            } else {
                plekerror.display_error(false, __('No actions defined for button', 'plekvetica'), __('Error', 'plekvetica'));
            }
        }
    },

    /**
     * Displays the current number of characters entered in a textarea
     * and the maximum allowed number of characters.
     * 
     * @param {object} textarea - The textarea element to display the count for.
     * 
     * If the element does not have a .textcount child, it will be appended.
     */
    showTextareaCharacters(textarea) {
        const currentLength = textarea.value.length;
        const maxLength = textarea.maxLength;
        let textCount = jQuery(textarea).parent().find('.textcount');
        if (empty(textCount)) {
            jQuery(textarea).parent().append('<div class="textcount"></div>');
            textCount = jQuery(textarea).parent().find('.textcount');
        }
        textCount.text(`${currentLength} / ${maxLength}`);
    },
    /**
     * Toggle the visibility of elements when a button is clicked.
     * The function is triggered on a button click event.
     * The button needs to have a data-show attribute with the id of the element to show.
     * The button needs to have a data-hide attribute with the id of the element to hide.
     * Both attributes are optional and can be omitted if only one element needs to be toggled.
     * @param {object} button - The button that triggered the event.
     */
    toggle_containers(button) {
        const show_id = !empty(button.dataset.show) ? button.dataset.show : false;
        const hide_id = !empty(button.dataset.hide) ? button.dataset.hide : false;
        if (show_id) {
            const show = document.getElementById(show_id);
            show.style.display = 'block';
        } else {
            console.error("No id found in data to show");
        }
        if (hide_id) {
            const hide = document.getElementById(hide_id);
            hide.style.display = 'none';
        } else {
            console.error("No id found in data to hide");
        }
        this.toggle_container_actions(button.id);
    },

    /**
     * Function to perform actions on a container toggle.
     * The function is used to execute specific code based on the id of the button that triggered the toggle.
     * The function is called by toggle_containers.
     * @param {string} button_id - The id of the button that triggered the toggle.
     */
    toggle_container_actions(button_id) {
        if (empty(button_id)) {
            return;
        }
        switch (button_id) {
            case 'tc_toggle_view_calendar':
            case 'tc_toggle_view_list':
                const show = document.getElementById(button_id).dataset.show;
                if (!empty(show)) {
                    this.url_replace_param('view', show);
                }
                break;

            default:
                break;
        }
    },
    /**
     * Process the data from the heartbeat event
     * Shows an overlay with the post lock info if the user is locked out
     * @param {object} event - The event object
     * @param {object} data - The data from the heartbeat event
     */
    processHeartbeat(event, data) {
        console.log(data);
        if (!empty(data['plek_user_locked_message'])) {
            //Shows an overlay with the post lock info
            if (empty(jQuery('#post_lock_overlay'))) {
                plektemplate.add_overlay('post_lock', data['plek_user_locked_message'], '', false);
                plektemplate.show_overlay('post_lock');
            }
        }
    },
    postTakeoverAction(currentTarget) {
        const buttonType = currentTarget.id;
        if (buttonType === 'post_takeover') {
            const post_id = currentTarget.dataset.post_id;
            const type = currentTarget.dataset.type
            var send_data = new FormData();
            send_data.append('action', 'plek_user_actions');
            send_data.append('do', 'post_takeover');
            send_data.append('post_id', post_id);
            send_data.append('type', type);

            plek_main.send_form(send_data, currentTarget);
        }
        if (buttonType === 'post_leave') {
            window.history.back();
        }
    }

}

plek_main.construct();

class plekPopup {

    constructor() {
    };



    /**
     * Shows the popup
     * 
     * @param {string} content The content as an html string
     * @param {string} id The ID of the popup
     * @param {bool} close_button If a close button should be visible
     */
    showPopup(content, id, close_button = true) {
        const zIndex = 100 + jQuery('.plek-popup').length;
        const close = (close_button) ? `<div class="close"><i class="fas fa-times"></i></div>` : '';
        const background = '<div class="popup-background" style="z-index: ' + zIndex + '"></div>';
        const container = `<div id="plek-popup-${id}" class="plek-popup"><div class="inner-container" style="z-index:${zIndex + 1}">${close}<div class="content">${content}</div></div>${background}</div>`
        jQuery('body').prepend(container);
        this.reposition_popup();
        jQuery('#plek-popup-' + id + ' .close').click(() => {
            new plekPopup().closePopup(id);
        });
    }
    /**
     * Closes the popup of the given ID
     * @param {string} id The ID of the popup
     */
    closePopup(id) {
        jQuery('#plek-popup-' + id).remove();
    }
    /**
     * Repositions the popup on user scroll
     */
    reposition_popup() {
        jQuery(".plek-popup .inner-container").css('top', window.pageYOffset + 150);
    }
    /**
     * Replaces the content part of a popup
     * @param {string} id The ID of the popup 
     * @param {string} content The content to insert
     * @todo Make animation to change the content
     */
    replaceContent(id, content) {
        jQuery(`#plek-popup-${id} .content`).html(content);
    }
}

/**
 * Some functions to make live easier
 * 
 */

/**
 * Checks if the given value is empty or null
 * @param {mixed} value 
 * @returns 
 */
function empty(value) {
    if (value === null) {
        return true;
    }
    if (typeof value === 'undefined') {
        return true;
    }
    //Check if it is a formdata
    if (value instanceof FormData) {
        // Use the FormData.entries() method to get an iterator of all key/value pairs
        for (let entry of value.entries()) {
            // If there's at least one entry, the FormData is not empty
            return false;
        }
    }
    if (typeof value === 'object' && Object.entries(value).length > 0) {
        return false;
    }
    //Checks if there are no entries in an object and no attributes (so it is not a dom element)
    if (typeof value === 'object' && Object.entries(value).length === 0 && typeof value.attributes === 'undefined') {
        return true;
    }
    if (typeof value === 'object' && typeof value.attributes === 'object' && value.attributes.length === 0) {
        return true;
    }
    if (value.length === 0) {
        return true;
    }
    return false;
}